import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { SubCategoriesDataService, SubCategoriesColumnsService } from '../../../services';
import { SubCategory, SubCategoriesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-sub-category-form',
  templateUrl: './sub-category-form.component.html',
  styleUrls: ['./sub-category-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SubCategoryFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public subCategory: SubCategory = {};
  public subCategoryForm: FormGroup = new FormGroup({});
  public subCategories: SubCategory[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private subCategoriesDataService: SubCategoriesDataService,
    public subCategoriesColumnsService: SubCategoriesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'SubCategoryFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Sub Category - Edit');
        this.getSubCategory(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.subCategory !== 'undefined') {
      this.subCategory = this.dynamicDialogConfig.data.subCategory;
    }
    if (typeof this.subCategory.id === 'undefined' || this.subCategory.id === null) {
      this.subCategory.id = null;
    }
    this.getSubCategories();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'SubCategoryFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'SubCategoryFormComponent');
  }

  getSubCategory(id: number): void {
    this.isLoading = true;
    this.subCategoriesDataService.getSubCategory(id).subscribe((response: SubCategory|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.subCategory = response;
        this.prepareFrom();
      }
    });
  }

  getSubCategories(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.subCategories !== 'undefined' && this.dynamicDialogConfig.data.subCategories.length > 0) {
      this.subCategories = this.dynamicDialogConfig.data.subCategories;
      return;
    }
    this.subCategoriesDataService.getSubCategories(this.parameters).subscribe((response: SubCategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.subCategories = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.subCategoryForm = new FormGroup({
      id: new FormControl(this.subCategory.id, []),
      name: new FormControl(this.subCategory.name, [Validators.required, ]),
      nameAr: new FormControl(this.subCategory.nameAr, []),
      nameFr: new FormControl(this.subCategory.nameFr, []),
      slug: new FormControl(this.subCategory.slug, [Validators.required, ]),
      slugAr: new FormControl(this.subCategory.slugAr, []),
      slugFr: new FormControl(this.subCategory.slugFr, []),
      picture: new FormControl(this.subCategory.picture, []),
      color: new FormControl(this.subCategory.color, []),
      description: new FormControl(this.subCategory.description, [Validators.required, ]),
      descriptionAr: new FormControl(this.subCategory.descriptionAr, []),
      descriptionFr: new FormControl(this.subCategory.descriptionFr, []),
      category: new FormControl((typeof this.subCategory.category === 'number') ? this.subCategory.category : this.subCategory.category?.id, []),
      ordering: new FormControl(this.subCategory.ordering, []),
      status: new FormControl(this.subCategory.status, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/sub-categories']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.subCategoryForm.controls).forEach((field: any) => {
        const control = this.subCategoryForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.subCategoryForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.subCategory = this.subCategoryForm.value;
    this.disableSubmit = true;
    console.log('subCategory', this.subCategory);
    if (typeof this.subCategory.id !== 'undefined' && this.subCategory.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.subCategoriesDataService.updateSubCategory(this.subCategory).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SUBCATEGORYUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SUBCATEGORYNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.subCategoriesDataService.addSubCategory(this.subCategory).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SUBCATEGORYCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SUBCATEGORYNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  setColor(event: any) {
    const control = this.subCategoryForm.get('color');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.subCategoryForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'sub-categories',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.subCategoryForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-sub-category-form',
  templateUrl: './sub-category-form.component.html',
  styleUrls: ['./sub-category-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSubCategoryFormComponent extends SubCategoryFormComponent {
}

